const axios = require('axios');
const qs = require("qs");

// Replace with your Spotify API credentials

const pageSize = 50; // Number of episodes per page
const totalEpisodesToRetrieve = 200; // Total number of episodes you want to retrieve

const getSpotifyToken = async () => {
    const data = qs.stringify({
      grant_type: "client_credentials",
    });
    const configGetToken = {
        method: "post",
      url: "https://accounts.spotify.com/api/token",
      headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
          "Basic NDJhOTM3NDQxODExNGZlNTgyNGVmN2QwOGYyZTc5MDY6ZDRjMGExNDlkYWQ3NGFmYzgwNmMxYjM0MWYzNmIwNjI=",
        },
        data: data,
    }; // TODO usar ENV vars
    const tokenResponse = await axios(configGetToken);
    return tokenResponse.data.access_token;
};

// Function to retrieve episodes using pagination
async function getEpisodes(offset, limit) {
    const accessToken = await getSpotifyToken(); // Obtain this through Spotify's authorization flow
  try {
    const response = await axios.get('https://api.spotify.com/v1/shows/2EscmnqVNqCx2SWMWbbB2W/episodes?market=CO', {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
      params: {
        offset: offset,
        limit: limit,
      },
      method: "get",
    });
    return response.data.items;
  } catch (error) {
    console.error('Error fetching episodes:', error.response ? error.response.data : error.message);
    return [];
  }
}

const getSpotifyEpisodes = async () => {
  const episodes = [];
  let offset = 0;
  
  while (offset < totalEpisodesToRetrieve) {
    const limit = Math.min(pageSize, totalEpisodesToRetrieve - offset);
    const pageEpisodes = await getEpisodes(offset, limit);
    episodes.push(...pageEpisodes);
    offset += pageSize;
  }

  return episodes;
}

module.exports = {
  getSpotifyEpisodes,
};